import { barkApi, useNamespace } from '@bark/bark-core';

export default async function EliteProSettings() {
	const sellerSubscriptions = await barkApi('seller/subscriptions');

	if (sellerSubscriptions?.data.length > 0) {
		const { EliteProSubscribed } = await import('./elite-pro/subscribed');
		EliteProSubscribed();
	} else {
		const { EliteProNotSubscribed } = await import('./elite-pro/not-subscribed');
		await useNamespace(['seller_settings_elite-pro-not-subscribed', 'seller_common']);
		EliteProNotSubscribed();
	}
}
